module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "login-box"
  }, [_c('div', {
    staticClass: "middle-box text-center animated fadeInDown"
  }, [_c('div', [_vm._m(0), _vm._v(" "), _c('h3', {
    staticClass: "login-title"
  }, [_vm._v("领鲜收银（商户端）")]), _vm._v(" "), _c('form', {
    staticClass: "m-t",
    attrs: {
      "role": "form",
      "onsubmit": "return false"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.credentials.name),
      expression: "credentials.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "账号",
      "required": ""
    },
    domProps: {
      "value": (_vm.credentials.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.credentials, "name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(2), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.credentials.password),
      expression: "credentials.password"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "placeholder": "密码",
      "required": ""
    },
    domProps: {
      "value": (_vm.credentials.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.credentials, "password", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary block full-width m-b",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.login
    }
  }, [_vm._v("立即登录")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "footer back-bor-null"
  }, [_vm._v(" © 2017 freshone all rights reserved ")])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    staticClass: "login-logo",
    attrs: {
      "src": require("../../../assets/img/logo.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-user"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-lock"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-79fc080d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/module/main/views/loginPage.vue
// module id = 215
// module chunks = 1